<span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.note-creation.message', params: { message: event.newValue }}]">
</span>
